import React, { Component } from "react";
import Form from "react-bootstrap/Form";
import _ from "lodash";
import uuid from "react-uuid";
import Loading from "../../../common/components/loading/loading";
import { getOrganizations } from "../../../common/services/auth/organizationService";
import SearchBox from "../../../common/components/search/searchBox";
import OrganizationsTable from "./organizationsTable";
import { withTranslation } from "react-i18next";

class Organizations extends Component {
  constructor(props) {
    super(props);

    this.handleOrganizationUpdated = this.handleOrganizationUpdated.bind(this);
    this.handlePaginationChanged = this.handlePaginationChanged.bind(this);
  }

  state = {
    organizations: [],
    searchQuery: "",
    activeOnly: true,
    sortColumn: { path: "name", order: "asc" },
    isLoading: true,
    paginationState: {
      currentPage: 0,
      pageSize: 10,
    },
  };

  async componentDidMount() {
    this.setState({
      organizations: await getOrganizations(),
      isLoading: false,
    });
  }

  handleSearch = (query) => {
    this.setState({
      searchQuery: query,
      paginationState: {
        ...this.state.paginationState,
        currentPage: 0,
      },
    });
  };

  handleSort = (colId, sort) => {
    if (colId && sort) {
      this.setState({
        sortColumn: {
          path: colId,
          order: sort,
        },
      });
    }
  };

  handleToggleActiveOnly = () => {
    this.setState({
      activeOnly: !this.state.activeOnly,
      paginationState: {
        ...this.state.paginationState,
        currentPage: 0,
      },
    });
  };

  handleOrganizationSelected = (organization, isNew = false) => {
    //Inject the callback function before calling back to the onClick event.
    this.props.onClick(organization, this.handleOrganizationUpdated, isNew);
  };

  handleOrganizationUpdated = (organization) => {
    const organizations = [...this.state.organizations];
    const index = organizations.findIndex(
      (u) => u.organizationId === organization.organizationId
    );
    if (index > -1) {
      organizations.splice(index, 1);
    }
    organizations.push(organization);
    this.setState({ organizations: organizations });
  };

  handlePaginationChanged(params) {
    if (params && params.api) {
      this.setState({
        paginationState: {
          currentPage: params.api.paginationGetCurrentPage(),
          pageSize: params.api.paginationGetPageSize(),
        },
      });
    }
  }

  getFilteredData = () => {
    const {
      sortColumn,
      searchQuery,
      organizations: allOrganizations,
      activeOnly,
    } = this.state;

    let filtered = allOrganizations;

    if (activeOnly) filtered = filtered.filter((u) => u.active);

    if (searchQuery)
      filtered = filtered.filter(
        (u) =>
          (u.name != null &&
            u.name.toLowerCase().includes(searchQuery.toLowerCase())) ||
          (u.shortName != null &&
            u.shortName.toLowerCase().includes(searchQuery.toLowerCase()))
      );

    const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);

    return { totalCount: filtered.length, data: sorted };
  };

  render() {
    const { searchQuery, activeOnly, isLoading, paginationState } = this.state;

    if (isLoading) return <Loading />;

    const { t, allowEdit } = this.props;

    const { totalCount, data: organizations } = this.getFilteredData();

    const newOrganization = {
      organizationId: uuid(),
      name: t("NewOrganization"),
    };

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <SearchBox value={searchQuery} onChange={this.handleSearch} />
          </div>
          <div className="col">
            <Form.Switch
              className="switch"
              type="switch"
              label={t("ActiveOnly")}
              checked={activeOnly}
              value={activeOnly}
              onChange={this.handleToggleActiveOnly}
            />
          </div>
          <div className="col">
            {allowEdit && (
              <button
                onClick={() =>
                  this.handleOrganizationSelected(newOrganization, true)
                }
                className="btn btn-sm btn-primary float-sm-right"
              >
                {t("AddOrganization")}
              </button>
            )}
          </div>
        </div>
        <p>{t("RetrievedOrganization", { count: totalCount })}</p>
        <OrganizationsTable
          organizations={organizations}
          onSort={this.handleSort}
          onRowClick={this.handleOrganizationSelected}
          onPaginationChanged={this.handlePaginationChanged}
          paginationState={paginationState}
        />
      </div>
    );
  }
}

export default withTranslation(["auth"])(Organizations);
